<template>
  <div class="">
    <b-modal
      hide-header
      hide-backdrop
      dialog-class="--full-screen"
      content-class="full-size-modale"
      :id="`modal_${player.index}`"
      :title="`${player.name}`"
    >
      <template #default="{ hide }">
        <div class="close-icon" @click="hide()">
          <img :src="require('@/assets/img/close.svg')" />
        </div>
        <div>
        </div>
        <div class="modal-content __case_modale">

          <BRow class="">
            <BCol md="12" sm="12">
              <div>
                <div class="oligarch-wrapper">
                  <div class="pt-5">
                    <BRow class="justify-content-center">
                      <BCol cols="12" md="5" class=" text-left align-self-center">
                        <div class="d-md-block mt-5 pt-5">
                          <div>
                            <label class="m-0 name-item fs-22px">{{ player.role }}</label>
                            <h3 class="name-item fs-58px">{{ player.name }}</h3>
                            <div class="name-item fs-26px text-primary mb-4">{{ player.title }}</div>
                          </div>
                        </div>

                        <div class="text-intro">
                          <label class="badge-secondary">{{ $t('appContent.entities_leak')}}: </label>
                          <div class="d-flex">
                              <div class="p-2 text-center">
                                  <h5 class="fs-44px name-item">{{ player.companies_nro }}</h5>
                                  <label class="">Companies</label>
                              </div>
                              <div class="p-2 text-center" v-if="player.trusts_nro > 0">
                                  <h5 class="fs-44px name-item">{{ player.trusts_nro }}</h5>                                       
                                  <label class="">Trusts</label>
                              </div>
                          </div>
                      </div>

                       
                        
                       
                      </BCol>
                        <BCol cols="12" md="5" class="text-center pt-5 justify-content-center">                          

                          <img width="100%" :src="getPicture(player.url, true, true)"  />
                        </BCol>
                    </BRow>

                    <BRow class="justify-content-center">   
                      
                      <BCol cols="12" md="5">
                        
                        <div class="mb-5">
                          <label class="badge-secondary">{{ $t('appContent.sanctioned_by')}}:</label>
                          <div class="text-left" v-for="(s, ix) in player.santioned_by" :key="ix">
                            <div class="p-3 border-bottom">
                             <a target="_blank" :href="s.link">
                              <img width="32px" :src="iconCountry(s)" /> {{ s.country }} - {{ s.year }}
                             </a>
                            </div>
                          </div> 
                          <div class="text-left" v-if="player.santioned_by==null">
                            <div class="p-3 border-bottom">
                                No sanctions
                             </div>
                          </div>
                        </div>    
                      </BCol>
                      <BCol cols="12" md="5">
                        <div id="player-connection" class="mb-5 item-content">
                          <label class="badge-secondary">{{ $t('appContent.providers')}}:</label>
                          <div>
                            <div class="" v-for="(p, ix) in player.providers" :key="ix">
                              <div class="p-3 border-bottom">
                                <a href="https://www.icij.org/investigations/cyprus-confidential/service-providers-cyprus-leak" target="_blank">
                                  {{ p.provider }}
                                </a>
                               </div>
                            </div>
                          </div>   
                        </div>
                      </BCol>
                      <BCol cols="12" md="10" class="align-self-center">
                        
                        <div class="content-default mt-3">

                          <div id="player-narrative" :data-toggle="dataToggle" class="mb-5 item-content">
                            <div>
                              <label class="badge-secondary d-inline-block">{{ $t('appContent.narrative_lab')}}:</label>
                            </div>
                            <div
                                v-html="player.narrative"
                                class=" pt-3 narrative"
                              ></div>
                            <b-collapse id="narrative-collapse" class="mt-2" v-if="player.narrative_expand">
                              <div
                                v-html="player.narrative_expand"
                                class="narrative"
                              ></div>
                            </b-collapse>
                            <div v-if="player.narrative_expand">
                              <b-button class="d-inline-block p-1 fs-12px font-weight-900" @click="openNarrative('narrative-collapse')" variant="no-class">{{ narrative_more }}</b-button>
                            </div>
                          </div>
                          <hr />
                          
                          <div>
                            <div id="player-connection" class="mb-3 item-content mb-5">
                              <label class="badge-secondary">{{ $t('appContent.companies_trusts')}}:</label>
                              <p
                              v-html="player.intro"
                              class="connection"
                              ></p>
                            </div>
                          </div>
                          <hr />

                          <div id="player-connection" class="mb-5 item-content">
                            <label class="badge-secondary">{{ $t('appContent.connection')}}:</label>
                            
                          <div
                                v-html="player.connection"
                                class="connection"
                              ></div>
                            <b-collapse id="connection-collapsable" class="mt-2" v-if="player.connection_expand">
                              <div
                                v-html="player.connection_expand"
                                class="connection"
                              ></div>
                            </b-collapse>

                            <div v-if="player.connection_expand">
                              <b-button class="d-inline-block p-1 fs-12px font-weight-900"  @click="openConnections('connection-collapsable')"  variant="no-class">{{ connections_more }}</b-button>
                            </div>

                          </div>

                          
                          <div id="player-response" class="mb-5 item-content" v-if="player && player.response">
                            <hr />
                            <label class="badge-secondary">{{ $t('appContent.response')}}:</label>
        
                            <div
                                  v-html="player.response"
                                  class="response"
                                ></div>
                            <b-collapse id="response-collapsable" class="mt-2" v-if="player.response_expand">
                              <div
                                v-html="player.response_expand"
                                class="response"
                              ></div>
                            </b-collapse>

                            <div v-if="player.response_expand">
                              <b-button class="d-inline-block p-1 fs-12px font-weight-900" @click="openResponses('response-collapsable')" variant="no-class">{{ responses_more }}</b-button>
                            </div>
                          
                          </div>

        
                        </div>


                      </BCol>
                    </BRow>
                  </div>
                </div>
                
              </div>

            </BCol>
          </BRow>

          <BRow>
  
            <div class="col-5 next-story">
              <h3 class="fs-18px mb-3 border-bottom">{{ $t("modal.prev_story") }}</h3>
  
              <BRow class="justify-content-between">
                <BCol
                  md="5"
                  sm="12"
                  class="mb-md-0"
                  v-if="findPrevProvider"
                  @click="hide()"
                  v-b-modal="
                    `modal_${findPrevProvider(player.url).index}`
                  "
                >
                <img width="100%" :src="getPicture(findPrevProvider(player.url).url, true)"  />
  
                </BCol>
                <BCol md="7" sm="12">
                  <h5
                    v-if="findPrevProvider(player.url).name"
                    class="
                      case_title fs-27px
                      text-capitalize
                    "
                  >
                    {{ findPrevProvider(player.url).name }}
                  </h5>
                  <div class="narrative-next font-weight-300 text-primary">
                    {{ translateIsoCountry(findPrevProvider(player.url).appointing_by_iso3) }} <arrowRight /> {{ translateIsoCountry( findPrevProvider(player.url).appointing_to_iso3) }}
                  </div>
                  <div class="w-100 mt-3">
                    <span
                      class="btn btn-primary font-weight-900"
                      v-if="findPrevProvider"
                      @click="hide()"
                      v-b-modal="
                        `modal_${findPrevProvider(player.url).index}`
                      "
                    >
                      {{ $t("modal.btn_read") }}</span
                    >
                  </div>
                </BCol>
              </BRow>
  
              
            </div>
            <div class="col-5 next-story">
              <h3 class="fs-18px mb-3 border-bottom text-right">{{ $t("modal.next_story") }}</h3>
  
              <BRow class="justify-content-between">
                <BCol
                  md="5"
                  sm="12"
                  class="mb-md-0"
                  v-if="findNextProvider"
                  @click="hide()"
                  v-b-modal="
                    `modal_${findNextProvider(player.url).index}`
                  "
                >
                <img width="100%" :src="getPicture(findNextProvider(player.url).url, true)"  />
  
                </BCol>
                <BCol md="7" sm="12">
                  <h5
                    v-if="findNextProvider(player.url).name"
                    class="
                      case_title fs-27px
                      text-capitalize
                    "
                  >
                    {{ findNextProvider(player.url).name }}
                  </h5>
                  <div class="narrative-next font-weight-300 text-primary">
                    {{ translateIsoCountry(findNextProvider(player.url).appointing_by_iso3) }} <arrowRight /> {{ translateIsoCountry( findNextProvider(player.url).appointing_to_iso3) }}
                  </div>
                  <div class="w-100 mt-3">
                    <span
                      class="btn btn-primary font-weight-900"
                      v-if="findNextProvider"
                      @click="hide()"
                      v-b-modal="
                        `modal_${findNextProvider(player.url).index}`
                      "
                    >
                      {{ $t("modal.btn_read") }}</span
                    >
                  </div>
                </BCol>
              </BRow>
  
              
            </div>
            
          </BRow>
        </div>
      </template>

      <template #modal-footer="{ cancel }">
       <div class="text-left justify-content-between d-flex">
        <b-button size="lg" variant="primary" @click="cancel()" class="mr-5">
          Back
        </b-button>
        <div class="d-inline-block">
          <div class="d-flex ">
            <label class="mr-3 d-md-block d-none">Share on: </label> 
          <SocialShare :layout="`home`" :title="$t('appContent.social_all')" share-link="https://www.icij.org/investigations/cyprus-confidential/oligarchs-offshore-clients/"/>
          </div>
        </div>
        
       </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import utils from "@/mixins/utils";
import { kebabCase } from "lodash";
import SocialShare from '@/components/SocialShare';
import arrowRight from '@/components/icons/arrowRight';

export default {
  name: "Modal",
  data() {
    return {
      myHtmlCode: "",
      nextProvider: {},
      hasMore: false,
      dataToggle: "",
      isMobile: false,
      narrative_more: `More ...`,
      connections_more: `More ...`,
      responses_more: `More ...`
    };
  },
  props: {
    player: {
      type: Object,
    },
  },
  mixins: [utils],
  components: {
    SocialShare,
    arrowRight
  },
  methods: {
    kebabCase,
    openNarrative(container) {
      if(this.narrative_more == `More ...`) {
        this.narrative_more = `Less ...`
        this.$root.$emit('bv::toggle::collapse', container)
      } else {
        this.narrative_more = `More ...`
        this.$root.$emit('bv::toggle::collapse', container)
      }
    },
    openConnections(container) {
      if(this.connections_more == `More ...`) {
        this.connections_more = `Less ...`
        this.$root.$emit('bv::toggle::collapse', container)
      } else {
        this.connections_more = `More ...`
        this.$root.$emit('bv::toggle::collapse', container)
      }
    },
    openResponses(container) {
      if(this.responses_more == `More ...`) {
        this.responses_more = `Less ...`
        this.$root.$emit('bv::toggle::collapse', container)
      } else {
        this.responses_more = `More ...`
        this.$root.$emit('bv::toggle::collapse', container)
      }
    },
    iconCountry(s) {
      return require(`@/assets/${kebabCase(s.country)}.png`)
    },
    getPic(name) {
      let strippedString = name.replace(/(<([^>]+)>)/gi, "");
      return this.kebabCase(strippedString);
    },
    findProvider(index) {
      try {
        return this.$store.state.players.all.find((p) => parseInt(p.index) === parseInt(index));
      } catch (_) {
        return null;
      }
    },
    playerLength() {
      return this.$store.state.players.all.length;
    },
    findNextProvider(url) {
      let index = this.$store.state.players.all.findIndex(
        (p) => p.url == url
      );
      if (index +1 == this.playerLength()) {
        index = -1;
      }
      return this.$store.state.players.all[index + 1];
    },
    findPrevProvider(url) {
      let index = this.$store.state.players.all.findIndex(
        (p) => p.url == url
      );
      if (index == 0) {
        index = this.playerLength() - 1;
      }
      return this.$store.state.players.all[index - 1];
    },
    showMore(){
      this.dataToggle = this.dataToggle ? "" : "collapse";
      this.hasMore = false
    },
    resize(){
      this.isMobile = window.innerWidth < window.innerHeight;
    }
  },
  beforeMount(){
    this.isMobile = window.innerWidth < window.innerHeight;
    window.addEventListener('resize',this.resize)
  },
  beforeUnmount(){
    window.removeEventListener('resize',this.resize)
  }
};
</script>

<style lang="scss">

.modal {
  padding-left: 0 !important;
}

.arrow-country {
  color: var(--app-color-red);
}

.oligarch-wrapper {
  p {
    font-size: 1.2rem !important;

    @media(max-width: 720px) {
      font-size: 1.3rem !important;
    }    
  }
}

.name-item {
  font-family: "headline-gothic-atf-rough-n1", sans-serif !important;;
  font-weight: 400 !important;
  font-style: normal !important;
}

.next-story {
  max-width: 700px;
  margin: 15px auto;
  padding: 15px;
  background-color: rgba(0, 0, 0, 0.77);
  color: #e3e3e3;

  img {
    overflow: hidden;
    object-fit: cover;
    overflow: hidden;
  }

  .narrative-next {
    max-height: 100px;
    overflow: hidden;
    font-size: 14px;
  }
}

.modal-dialog.--full-screen {
  max-width: 100%;
  margin: 0;
  .modal-content.full-size-modale {
    width: 100vw;
    min-height: 100vh;
    background-color: #000000d9;
    border: none;
    border-radius: unset;
  }
  .close-icon {
    img {
      transform: rotate(45deg);
      width: 3.5rem;
      background: #fff;
      border-radius: 50%;
    }
    cursor: pointer;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }
  .modal-body {
    padding: 0;
    max-width: 1020px;
    margin: 0 auto;
  }

  .modal-footer {
    width: 100%;
    max-width: 1020px;
    margin: 0 auto;
    position: sticky;
    bottom: 0;
    padding: 10px;
    background: #fff;
    z-index: 999;
    text-align: left;
    justify-content: start;
  }

  .modal-content.__case_modale {
    box-shadow: none;
    border: none;
    border-radius: 0 !important;
  }

  #default {
    display: block;

    .content-default {
      width: 100%;
    }

    .item-content {
      margin: 0 auto;
      color: #fff;
    }

    .avatar {
      width: 7rem;
      object-fit: cover;
    }
    .red-filter {
      position: absolute;
      top: 0;
      left: 0;
      height: 0;
      bottom: 0;
      background-color: var(--app-color-red);
      z-index: 1;
      width: 7rem;
      height: 7rem;
      border-radius: 50%;
      opacity: 0.5;
    }
    p {
      font-size: 1.3rem;
      line-height: 1.8rem;
      margin-bottom: 1.2rem;
    }
  }
  .arrow-right {
    transform: rotate(270deg);
    width: 2.5rem;
  }
  .__case-pic {
    width: 100%;
    height: 15rem;
    object-fit: cover;
    object-position: center;
  }
  @media (max-width: 720px) {
    #sideBare {
      position: unset;
      order: 2;
    }
    #header {
      order: 1;
    }
    #content {
      order: 3;
    }
    .modal-body {
      padding: 0;
    }
    .close-icon {
      display: block;
      top: 15vh;
      left: 85vw;
    }
  }
}

.c-primary {
  color: var(--app-color-red) !important;
}

.oligarch-wrapper {
  position: relative;
  padding: 10px;
  min-height: 360px;

  label {
    font-size: 12px;
    padding: 0 5px;
  }

  .arrow-down-container {
    position: sticky;
    bottom: 0;
    width: 100%;
    padding: 35px 0;
    text-align: center;
    background: linear-gradient(rgba(255, 255, 255, 0), #262626d1);
  }
}
</style>
